export const useScrollUtils = () => {
  const goToSavedScrollPosition = (storageKey: string) => {
    if (!window) return

    const savedScrollPosition = sessionStorage.getItem(storageKey)
    if (!savedScrollPosition) return

    window.scrollTo(0, parseInt(savedScrollPosition))
    sessionStorage.removeItem(storageKey)
  }

  const saveScrollPosition = (storageKey: string) => {
    if (!window) return

    sessionStorage.setItem(storageKey, String(window.scrollY))
  }

  const scrollTop = (position = 0) => {
    if (!window) return

    window.scrollTo({ behavior: 'smooth', top: position })
  }

  return {
    goToSavedScrollPosition,
    saveScrollPosition,
    scrollTop,
  }
}
